module.exports = __webpack_public_path__ + "media/images/pages/impact/impact_report-7089f2582652ff865f3fb07c104e6066.png";